import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TrendencyReqService } from '@trendency/http';
import { BehaviorSubject, Observable, map } from 'rxjs';

import { environment } from 'src/environments/environment';
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocaleContextService {
  public readonly currentLocalizedSlugs$ = new BehaviorSubject<object>({});
  public readonly currentLocaleContext$ = new BehaviorSubject<string>('');
  public readonly currentPageType$ = new BehaviorSubject<string>('');

  constructor(private readonly reqService: TrendencyReqService, private readonly translate: TranslateService) {}

  get lang(): string {
    return this.translate.currentLang;
  }

  getLocalizedSlugsByLocaleContext$(pageType: string, localeContext: string): Observable<{ [key: string]: string }> {
    return this.reqService.get(`/en/content/by_locale_context/${pageType}/${localeContext}/locales`).pipe(
      map((data: any) => {
        return data?.locales || {};
      })
    );
  }

  getLocalizedSlugsByLocaleContextFromCsodas$(pageType: string, localeContext: string): Observable<{ [key: string]: string }> {
    const csodasApiUrl = environment.csodasApiUrl;
    let csodasApiUrlStr: string | undefined;

    if (
      typeof csodasApiUrl === 'object' &&
      csodasApiUrl !== null &&
      typeof csodasApiUrl.clientApiUrl === 'string'
    ) {
      csodasApiUrlStr = csodasApiUrl.clientApiUrl;
    } else if (typeof csodasApiUrl === 'string') {
      csodasApiUrlStr = csodasApiUrl;
    }

    if (!csodasApiUrlStr) {
      throw new Error('csodasApiUrl is not defined or has an invalid type');
    }

    if (csodasApiUrlStr.endsWith('/')) {
      csodasApiUrlStr = csodasApiUrlStr.slice(0, -1);
    }
    return this.reqService.get(`${csodasApiUrlStr}/hu/content/by_locale_context/${pageType}/${localeContext}/locales`).pipe(
      map((data: any) => {
        return data?.locales || {};
      })
    );
  }

  getMergedLocalizedSlugsByLocaleContext$(pageType: string, localeContext: string): Observable<{ [key: string]: string }> {
    this.resetLocaleContext();
    this.currentPageType$.next(pageType);

    return forkJoin({
      main$: this.getLocalizedSlugsByLocaleContext$(pageType, localeContext),
      csodas$: this.getLocalizedSlugsByLocaleContextFromCsodas$(pageType, localeContext),
    }).pipe(
      map((result) => {
        const merged = { ...result.main$, ...result.csodas$ };
        this.currentLocalizedSlugs$.next(merged);
        return merged;
      })
    );
  }

  private resetLocaleContext(): void {
    this.currentLocalizedSlugs$.next({});
    this.currentLocaleContext$.next('');
    this.currentPageType$.next('');
  }
}
